







import { Component } from "vue-property-decorator";
import WindowVue from "../../core/window/WindowVue";
import { Mixins } from "vue-mixin-decorator";
import LifeCycle from "../../core/decorator/LifeCycle";
import OtherTextComponent from "./OtherTextComponent.vue";

@Component({
  components: { OtherTextComponent }
})
export default class EditOtherTextWindow extends Mixins<
  WindowVue<string, never>
>(WindowVue) {
  private rawText: string = "";

  @LifeCycle
  public async mounted() {
    await this.init();
  }
}
